<div
  class="meeting-health-badge"
  (click)="toggleTooltip()"
  (mouseenter)="openTooltip()"
  (mouseleave)="scheduleClose()"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
>
  <svg width="26" height="26" viewBox="0 0 26 26" class="progress-circle">
    <circle cx="13" cy="13" r="10.5" fill="transparent" stroke="#E5E5E5" stroke-width="4.5" />
    <circle
      cx="13"
      cy="13"
      r="10.5"
      fill="transparent"
      stroke-width="4.5"
      [attr.stroke-dasharray]="2 * 3.14159 * 10.5"
      [attr.stroke-dashoffset]="strokeDashoffsetSmall"
      stroke-linecap="round"
      transform="rotate(-90 13 13)"
      class="progress-fill"
    />
  </svg>
  @if (isComplete) {
    <div class="badge-content">
      <mat-icon class="check-icon">check</mat-icon>
    </div>
  }
  @if (avgConfidenceScore !== null && avgConfidenceScore < 0.7) {
    <div class="warning-dot"></div>
  }
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayHasBackdrop]="isTooltipPinned"
  [cdkConnectedOverlayBackdropClass]="'meeting-health-backdrop'"
  (backdropClick)="closeTooltipFromBackdrop()"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isTooltipOpen"
  [cdkConnectedOverlayPositions]="[
    {
      originX: 'center',
      originY: 'bottom',
      overlayX: 'center',
      overlayY: 'top',
      offsetY: 8,
    },
  ]"
>
  <div class="meeting-health-tooltip" (mouseenter)="openTooltip()" (mouseleave)="scheduleClose()">
    <div class="tooltip-header">
      <div class="tooltip-progress">
        <svg width="26" height="26" viewBox="0 0 26 26" class="section-icon">
          <circle cx="13" cy="13" r="10.5" fill="none" stroke="#E5E7EB" stroke-width="4.5" />
          <circle
            cx="13"
            cy="13"
            r="10.5"
            fill="none"
            stroke-width="4.5"
            [attr.stroke-dasharray]="2 * 3.14159 * 10.5"
            [attr.stroke-dashoffset]="strokeDashoffsetSmall"
            stroke-linecap="round"
            transform="rotate(-90 13 13)"
            class="progress-fill"
          />
        </svg>
        @if (isComplete) {
          <div class="badge-content">
            <mat-icon class="check-icon">check</mat-icon>
          </div>
        }
      </div>
      <h3>{{ 'CALLS.MEETING_HEALTH.TITLE' | translate }}</h3>
    </div>

    <div class="tooltip-section">
      <div class="section-header">
        <span class="section-title">{{ 'CALLS.MEETING_HEALTH.COMPLETED_TEXT' | translate: { completed: completedCount, total: totalCount } }}</span>
      </div>

      <div class="tooltip-divider"></div>

      <div class="checklist-items">
        @for (item of sortedItems; track $index) {
          <div class="checklist-item" [class.completed]="item.isComplete">
            @if (item.isComplete) {
              <mat-icon class="item-check">check</mat-icon>
            } @else {
              <mat-icon class="item-circle">radio_button_unchecked</mat-icon>
            }
            <div class="item-content">
              <span class="item-label">
                {{ item.label | translate }}
                @if (item.progress) {
                  <span class="item-progress"> ({{ item.progress }})</span>
                }
                @if (!item.isComplete && item.helpLink) {
                  <a class="help-link" (click)="$event.stopPropagation(); intercomService.openHelpArticle(item.helpLink)">
                    <mat-icon class="help-icon">info_outline</mat-icon>
                  </a>
                }
              </span>
              @if (item.subtext && !item.isComplete) {
                <span class="item-subtext">
                  {{ item.subtext | translate }}
                </span>
              }
            </div>
          </div>
        }
      </div>

      @if (avgConfidenceScore !== null) {
        <div class="audio-quality-divider"></div>

        <div class="audio-quality-section">
          <mat-icon class="audio-icon" [class.good]="avgConfidenceScore >= 0.7" [class.poor]="avgConfidenceScore < 0.7"> graphic_eq </mat-icon>
          <span class="audio-quality-text">
            {{ avgConfidenceScore >= 0.7 ? ('CALLS.AUDIO_QUALITY.GOOD' | translate) : ('CALLS.AUDIO_QUALITY.POOR' | translate) }}
            @if (avgConfidenceScore < 0.7) {
              <a
                class="audio-help-link"
                (click)="$event.stopPropagation(); intercomService.openHelpArticle('https://help.wiseworks.ai/en/articles/489194-live-meeting-accuracy-tips')"
              >
                <mat-icon class="help-icon">info_outline</mat-icon>
              </a>
            }
          </span>
        </div>
      }
    </div>
  </div>
</ng-template>
